import baseIcon from '../base.mjs';

const SiSupabase = baseIcon("Supabase", "#3FCF8E", "M11.9 1.036c-.015-.986-1.26-1.41-1.874-.637L.764 12.05C-.33 13.427.65 15.455 2.409 15.455h9.579l.113 7.51c.014.985 1.259 1.408 1.873.636l9.262-11.653c1.093-1.375.113-3.403-1.645-3.403h-9.642z");
const SiSupabase$1 = SiSupabase;

export { SiSupabase$1 as default };
